import { useStaticQuery, graphql } from "gatsby"

export const useSwatch = () => {
  const { swatches } = useStaticQuery(graphql`
    query SWATCHES {
      swatches: allSanitySettingSwatches {
        edges {
          node {
            id: _id
            name
            slug {
              current
            }
            linked
            colour {
              hex
            }
            image {
              asset {
                url
              }
            }
          }
        }
      }
    }
  `)

  const items = swatches?.edges?.map(({ node }) => node) || []

  const transformSwatch = ({ image, name, slug }) => {
    return {
      id: slug?.current,
      name,
      image: `${image?.asset?.url}?w=50`,
    }
  }

  const getSwatchByHandle = handle => items?.filter(group => group?.slug?.current === handle).map(transformSwatch)?.[0] || false

  const getSwatchByProduct = product =>
    items
      ?.filter(group => group?.slug?.current === product?.tags?.find(tag => tag.includes("swatch:"))?.replace("swatch:", ""))
      .map(transformSwatch)?.[0] || false

  const getSwatch = value => {
    const result = items.filter(
      swatch =>
        swatch?.name?.toLowerCase() === value?.toLowerCase() ||
        swatch?.linked?.map(item => item.toLowerCase()).includes(value?.toLowerCase()) ||
        swatch?.slug?.current?.toLowerCase() === value?.toLowerCase()
    )
    return result?.length
      ? {
          name: result?.[0]?.name,
          slug: result?.[0]?.slug?.current,
          linked: result?.[0]?.linked,
          colour: result?.[0]?.colour?.hex,
          image: `${result?.[0]?.image?.asset?.url}?w=100` || false,
        }
      : false
  }

  return {
    items,
    getSwatchByHandle,
    getSwatchByProduct,
    getSwatch,
  }
}
